import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var CampaignFilterObjectFunnelStageInline;
(function (CampaignFilterObjectFunnelStageInline) {
    CampaignFilterObjectFunnelStageInline["OFFER"] = "OFFER";
    CampaignFilterObjectFunnelStageInline["ORDER"] = "ORDER";
})(CampaignFilterObjectFunnelStageInline || (CampaignFilterObjectFunnelStageInline = {}));
export var PushMode;
(function (PushMode) {
    PushMode["AUTO"] = "AUTO";
    PushMode["MANUAL"] = "MANUAL";
    PushMode["NONE"] = "NONE";
})(PushMode || (PushMode = {}));
export var FlightStatus;
(function (FlightStatus) {
    FlightStatus["BEFORE_RUNNING"] = "BEFORE_RUNNING";
    FlightStatus["WAITING_FOR_SCREENSHOT"] = "WAITING_FOR_SCREENSHOT";
    FlightStatus["RUNNING"] = "RUNNING";
    FlightStatus["FINISHED"] = "FINISHED";
})(FlightStatus || (FlightStatus = {}));
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["DE"] = "DE";
    LanguageCode["EN"] = "EN";
    LanguageCode["FR"] = "FR";
    LanguageCode["IT"] = "IT";
})(LanguageCode || (LanguageCode = {}));
export var ReportingType;
(function (ReportingType) {
    ReportingType["WEEKLY"] = "WEEKLY";
    ReportingType["BY_END_DATE"] = "BY_END_DATE";
    ReportingType["FLIGHT_EXPIRATION"] = "FLIGHT_EXPIRATION";
    ReportingType["MANUAL"] = "MANUAL";
})(ReportingType || (ReportingType = {}));
export var Gender;
(function (Gender) {
    Gender["MALE"] = "MALE";
    Gender["FEMALE"] = "FEMALE";
})(Gender || (Gender = {}));
export var FormOfCommunication;
(function (FormOfCommunication) {
    FormOfCommunication["INFORMAL"] = "INFORMAL";
    FormOfCommunication["FORMAL"] = "FORMAL";
})(FormOfCommunication || (FormOfCommunication = {}));
export var Role;
(function (Role) {
    Role["ADVERTISER"] = "ADVERTISER";
    Role["AGENCY"] = "AGENCY";
    Role["BROKER"] = "BROKER";
    Role["OTHER"] = "OTHER";
    Role["PUBLISHER"] = "PUBLISHER";
})(Role || (Role = {}));
export var InternalOrigin;
(function (InternalOrigin) {
    InternalOrigin["DIGITAL_SALES"] = "DIGITAL_SALES";
    InternalOrigin["TEAM_ZH"] = "TEAM_ZH";
    InternalOrigin["TEAM_LU"] = "TEAM_LU";
    InternalOrigin["TEAM_SG"] = "TEAM_SG";
    InternalOrigin["TEAM_AUSLAND"] = "TEAM_AUSLAND";
    InternalOrigin["C_LEVEL"] = "C_LEVEL";
    InternalOrigin["GRUNER_AND_JAHR"] = "GRUNER_AND_JAHR";
})(InternalOrigin || (InternalOrigin = {}));
export var Invoicing;
(function (Invoicing) {
    Invoicing["NONE"] = "NONE";
    Invoicing["AFTER_RUNTIME"] = "AFTER_RUNTIME";
    Invoicing["START_RUNTIME"] = "START_RUNTIME";
    Invoicing["IMMEDIATELY"] = "IMMEDIATELY";
    Invoicing["BY_DELIVERY_500"] = "BY_DELIVERY_500";
    Invoicing["BY_POSITION_END_DATE_MONTH"] = "BY_POSITION_END_DATE_MONTH";
    Invoicing["BY_POSITION_END_DATE_QUARTER"] = "BY_POSITION_END_DATE_QUARTER";
    Invoicing["BY_POSITION_END_DATE_HALFYEAR"] = "BY_POSITION_END_DATE_HALFYEAR";
})(Invoicing || (Invoicing = {}));
export var InvoiceDeliveryType;
(function (InvoiceDeliveryType) {
    InvoiceDeliveryType["POSTAL"] = "POSTAL";
    InvoiceDeliveryType["DIGITAL"] = "DIGITAL";
})(InvoiceDeliveryType || (InvoiceDeliveryType = {}));
export var InvoiceState;
(function (InvoiceState) {
    InvoiceState["NONE"] = "NONE";
    InvoiceState["OPEN"] = "OPEN";
    InvoiceState["CHARGED"] = "CHARGED";
    InvoiceState["PAID"] = "PAID";
    InvoiceState["CANCELED"] = "CANCELED";
    InvoiceState["ARCHIVED"] = "ARCHIVED";
    InvoiceState["SPLIT"] = "SPLIT";
    InvoiceState["BAD_DEBT"] = "BAD_DEBT";
})(InvoiceState || (InvoiceState = {}));
export var ExternalOrderProvider;
(function (ExternalOrderProvider) {
    ExternalOrderProvider["XANDR"] = "XANDR";
    ExternalOrderProvider["GOOGLE"] = "GOOGLE";
    ExternalOrderProvider["ADOMIK"] = "ADOMIK";
    ExternalOrderProvider["NONE"] = "NONE";
})(ExternalOrderProvider || (ExternalOrderProvider = {}));
export var CampaignPositionType;
(function (CampaignPositionType) {
    CampaignPositionType["DIGITAL"] = "DIGITAL";
    CampaignPositionType["PRINT"] = "PRINT";
    CampaignPositionType["RADIO"] = "RADIO";
    CampaignPositionType["TV"] = "TV";
    CampaignPositionType["POSTNETZ_ANALOG"] = "POSTNETZ_ANALOG";
    CampaignPositionType["POS"] = "POS";
    CampaignPositionType["ALL"] = "ALL";
})(CampaignPositionType || (CampaignPositionType = {}));
export var VisibilityMode;
(function (VisibilityMode) {
    VisibilityMode["VISIBLE"] = "VISIBLE";
    VisibilityMode["HIDDEN"] = "HIDDEN";
    VisibilityMode["TRANSPARENT"] = "TRANSPARENT";
})(VisibilityMode || (VisibilityMode = {}));
export var CampaignStage;
(function (CampaignStage) {
    CampaignStage["OFFERED"] = "OFFERED";
    CampaignStage["OFFER_DENIED"] = "OFFER_DENIED";
    CampaignStage["ALTERNATE_QUOTE"] = "ALTERNATE_QUOTE";
    CampaignStage["BOOKED"] = "BOOKED";
    CampaignStage["PERFORMANCE"] = "PERFORMANCE";
    CampaignStage["DRAFT"] = "DRAFT";
    CampaignStage["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    CampaignStage["ARCHIVED"] = "ARCHIVED";
    CampaignStage["PREPAYMENT"] = "PREPAYMENT";
})(CampaignStage || (CampaignStage = {}));
export var BillingType;
(function (BillingType) {
    BillingType["FIXED_PRICE"] = "FIXED_PRICE";
    BillingType["MMP"] = "MMP";
    BillingType["CPC"] = "CPC";
    BillingType["CPCV"] = "CPCV";
    BillingType["CPM"] = "CPM";
    BillingType["VCPM"] = "VCPM";
    BillingType["CPD"] = "CPD";
    BillingType["CPW"] = "CPW";
    BillingType["MAX_CPM"] = "MAX_CPM";
    BillingType["TRADING_CPM"] = "TRADING_CPM";
    BillingType["CPS"] = "CPS";
})(BillingType || (BillingType = {}));
export var Unit;
(function (Unit) {
    Unit["MM"] = "MM";
    Unit["COLUMN"] = "COLUMN";
})(Unit || (Unit = {}));
export var DocumentEntityType;
(function (DocumentEntityType) {
    DocumentEntityType["ACCOUNT"] = "ACCOUNT";
    DocumentEntityType["CAMPAIGN"] = "CAMPAIGN";
    DocumentEntityType["POST_ACCOUNT"] = "POST_ACCOUNT";
    DocumentEntityType["SALES_PROMOTION"] = "SALES_PROMOTION";
})(DocumentEntityType || (DocumentEntityType = {}));
export var DocumentCategory;
(function (DocumentCategory) {
    DocumentCategory["OFFER"] = "OFFER";
    DocumentCategory["CONFIRMATION"] = "CONFIRMATION";
    DocumentCategory["INVOICE"] = "INVOICE";
    DocumentCategory["RECEIPT"] = "RECEIPT";
    DocumentCategory["CONTRACT"] = "CONTRACT";
    DocumentCategory["REPORT"] = "REPORT";
    DocumentCategory["OTHER"] = "OTHER";
})(DocumentCategory || (DocumentCategory = {}));
export var ImportStatus;
(function (ImportStatus) {
    ImportStatus["PROCESSING"] = "PROCESSING";
    ImportStatus["SUCCESS"] = "SUCCESS";
    ImportStatus["ERROR"] = "ERROR";
})(ImportStatus || (ImportStatus = {}));
export var DocumentExtension;
(function (DocumentExtension) {
    DocumentExtension["PDF"] = "PDF";
    DocumentExtension["XLSX"] = "XLSX";
})(DocumentExtension || (DocumentExtension = {}));
